import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Button } from "@/components/button";
import { DynamicForm } from "@/components/dynamic-form";
import { useEmrContext } from "@/hooks/emr-context";
import { useDynamicForm } from "@/hooks/form";
import { fetchFormResponse } from "@/services/form";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { ComposerShell } from "./composer-shell";
/** Read-only form viewer: fetches an existing form response and renders all fields as disabled. */
export function FormViewerComposerBody(_ref) {
  var _formQuery$data, _formQuery$data$schem;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var parsed = function () {
    try {
      return JSON.parse(composer.content);
    } catch (_unused) {
      return null;
    }
  }();
  var formQuery = useQuery(["form-response-view", patientUid, parsed === null || parsed === void 0 ? void 0 : parsed.formResponseUid], function () {
    return fetchFormResponse(patientUid, parsed.formResponseUid);
  }, {
    enabled: Boolean(patientUid) && Boolean(parsed === null || parsed === void 0 ? void 0 : parsed.formResponseUid)
  });
  var dynamic = useDynamicForm(formQuery.data);
  var disabledSchema = dynamic.schema.map(function (obs) {
    return _objectSpread(_objectSpread({}, obs), {}, {
      disabled: true
    });
  });
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: ((_formQuery$data = formQuery.data) === null || _formQuery$data === void 0 ? void 0 : _formQuery$data.display_name) || composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-close-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CLOSE, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("close", {
      defaultValue: "Close"
    }))
  }, formQuery.isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-48 items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("loading", {
    defaultValue: "Loading…"
  }))) : formQuery.data ? /*#__PURE__*/React.createElement("div", {
    className: "min-h-96"
  }, /*#__PURE__*/React.createElement(DynamicForm, {
    schema: disabledSchema,
    layout: (_formQuery$data$schem = formQuery.data.schema) === null || _formQuery$data$schem === void 0 ? void 0 : _formQuery$data$schem.layout,
    response: dynamic.response,
    tags: dynamic.tags,
    onFieldChange: function onFieldChange() {
      return undefined;
    }
  })) : null);
}